export const GET_FLOW_TYPES = 'GET_FLOW_TYPES';
export const GET_FLOW_TYPES_SUCCESS = 'GET_FLOW_TYPES_SUCCESS';
export const GET_FLOW_TYPES_FAILED = 'GET_FLOW_TYPES_FAILED';